import { render } from "./fmaas.html?vue&type=template&id=7c15b23f&scoped=true&lang=html&external"
import script from "./fmaas.vue?vue&type=script&lang=js"
export * from "./fmaas.vue?vue&type=script&lang=js"

import "./_fmaas.mobile.scss?vue&type=style&index=0&id=7c15b23f&lang=scss&scoped=true&external"
import "./_fmaas.desktop.scss?vue&type=style&index=1&id=7c15b23f&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c15b23f"]])

export default __exports__